import z from "zod";

export const weightUnitsEnum = z.enum(["kg", "lbs", "oz"]);

export const heightUnitsEnum = z.enum(["cm", "in", "ft"]);